import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-white px-4 py-12" data-id="element-75" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-76" data-mp="32nulgo2wc31d">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-77" data-mp="32p5qer82vgu2">
          🏃 Combo Completo Running 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-78" data-mp="36n3bpiyq9is6">
          Planificaciones de running, fuerza y técnica para corredores de todos los niveles y para
          profesores que organizan alumnos o grupos.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-79" data-mp="3lem0o69kenno">
          Identificás tu nivel, elegís tu objetivo y seguís el entrenamiento paso a paso.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-80" data-mp="3qfjj8jyhljpp">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent" href="mailto:compradigitalyaa@gmail.com" data-id="element-81" data-mp="2eyt6ehzk5tn4">
            <MailIcon className="h-4 w-4" data-id="element-82" data-mp="3gapd7j63ckfz" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-83" data-mp="3v7q5pow3wjfi">
            <GlobeIcon className="h-4 w-4" data-id="element-84" data-mp="81foxu0vmo35" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-85" data-mp="32w2lsidfaa9">
            <InstagramIcon className="h-4 w-4" data-id="element-86" data-mp="qti0iqynve6j" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-line pt-6" data-id="element-87" data-mp="mrwplb5ot9yz">
          <p className="text-base font-black uppercase text-ink" data-id="element-88" data-mp="mthk50s04swu">
            🏃 De cero a 21K. Un camino claro para cada objetivo.
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-89" data-mp="yu7hysrlhryq">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-90" data-mp="13s98fyrcotk8" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}